// extracted by mini-css-extract-plugin
export default {"centered-spinner":"CenteredSpinner_centered-spinner__57jti"};